// frontend/src/utils/planningInherit.js
//
// The "inherit" choice of a SaaS planning-override select, shared by the two
// grids that offer one — Supplier setup (pages/supplierPlanningColumns.js,
// Store → Supplier) and Item setup (pages/itemPlanningColumns.js,
// Supplier → Item-location).
//
// Inherit is an editor SENTINEL, never a wire value: a rich-select needs a
// pickable entry for "no override", and `null` cannot be one. Every path that
// writes a cell (`parseChoice`) turns it back into null before the row is
// touched, so a bulk-save payload carries null and nothing else.

export const INHERIT = '__inherit__';

const EM_DASH = '—';

/** The merchant-facing name of an inventory target mode. */
export const modeLabel = (t, mode) => t(`storeSettings.inventoryTargetMode_${mode}`);

/**
 * What a rich-select or a paste handed the cell, as a wire value.
 *
 * `null` for the inherit sentinel and for every empty spelling; the code when
 * given a code or a label (case-insensitive — a merchant pastes what the
 * export wrote); `undefined` when nothing matches, which the valueSetter
 * turns into a refused edit.
 */
export function parseChoice(raw, codes, labelOf, inheritOptionLabel) {
  if (raw === null || raw === undefined || raw === INHERIT || raw === '' || raw === EM_DASH) {
    return null;
  }
  if (codes.includes(raw)) return raw;
  const text = String(raw).trim().toLowerCase();
  if (text === inheritOptionLabel.toLowerCase()) return null;
  return codes.find((code) => code.toLowerCase() === text || labelOf(code).toLowerCase() === text);
}
